import { ParentContext } from 'global/cnr/contexts/ParentContext'
import { sendMatchMessage } from 'projectSpecific/sports/cnr/reducers/SportsDataReducer'
import { useCallback, useContext, useRef, useState } from 'react'
import { GolfTournamentContext } from '../cnr/contexts/GolfTournamentContext'
import { golfTournamentHelpers } from '../cnr/reducers/reducerHelpers/golfTournamentHelpers'
import { calcMatchStatus } from '../golfCalcs/calcMatchStatus'

export const _allowGolfUpdates = true

export const useGolfMatches = () => {

  const parentContext = useContext(ParentContext)
  const { fns, states } = parentContext ?? {}
  const { paps_state } = states ?? {}
  const { pathViews } = paps_state ?? {}
  const { database_fns } = fns

  const golfTournamentContext = useContext(GolfTournamentContext)
  const { golfTournament_state } = golfTournamentContext ? golfTournamentContext : {}
  const { teams, golfCourse, matches_state } = golfTournament_state ?? {}
  const { holes } = golfCourse ?? {}

  const infoRef = useRef({
    holes,
    teams,
    pathViews,
    matches_state,
  })

  // Update the ref on every render
  infoRef.current = {
    holes,
    teams,
    pathViews,
    matches_state,
  }

  const [updating, setUpdating] = useState()

  const handleUpdate_golfMatchHoleWinners = useCallback(async ({
    golfMatch,
    callback
  }) => {

    const {
      pathViews,
    } = infoRef.current

    setUpdating(true);

    try {

      const _matchData = { ...golfMatch };

      const result = await golfTournamentHelpers.updateMatchScore(
        database_fns,
        pathViews.golfTournaments,
        pathViews,
        _matchData,
        callback
      );

      return result;

    } catch (error) {
      console.error(error);
      throw error;

    } finally {

      setUpdating(false);

    }

  }, [pathViews]);


  const handleUpdate_golfMatchScore = useCallback(async ({ matchUpdate, callback, matchStatus, autoScoringOn }) => {

    setUpdating(true);

    const {
      holes,
      teams,
      pathViews,
      matches_state,
    } = infoRef.current

    try {
      const { golfMatch, holeNumber, winningTeam, winningGolfer, playerScoring } = matchUpdate
      const matchData = { ...golfMatch };

      // create holeWinners if it does not exist
      if (!matchData.holeWinners) {
        matchData.holeWinners = {};
      }

      matchData.holeNumber = holeNumber;

      // REMOVE the score
      if (winningTeam === -1) {

        return await golfTournamentHelpers.removeMatchScore(
          database_fns,
          pathViews.golfTournaments,
          pathViews,
          matchData,
          holeNumber,
          callback
        );
      }

      // Update player scoring
      if (playerScoring) {

        if (!matchData.holeScores) {
          matchData.holeScores = {};
        }

        let _playerScoring = {};

        if (playerScoring.team1) {
          _playerScoring = {
            ...playerScoring.team1
          };
        }

        if (playerScoring.team2) {
          _playerScoring = {
            ..._playerScoring,
            ...playerScoring.team2
          };
        }

        matchData.holeScores[holeNumber] = _playerScoring;

      }

      const count = Object.keys(matchData.holeWinners).length;

      matchData.holeWinners[holeNumber] = {
        winningTeam,
        order: count,
        createdAt: Date.now()
      };

      if (winningGolfer) {
        matchData.holeWinners[holeNumber].winningGolfer = winningGolfer;
      }

      try {

        let _holeResult;

        if (winningTeam > 0) {

          const _team = teams ? _.find(teams, { teamNumber: winningTeam }) : {};

          const { name: name_winningTeam } = _team || {};

          if (name_winningTeam) {
            _holeResult = name_winningTeam + ' has won hole #' + holeNumber + '.';
          } else {
            _holeResult = winningTeam + ' has won hole #' + holeNumber + '.';
          }

        } else {
          _holeResult = 'Hole # ' + holeNumber + ' was tied.';
        }

        const _matchStatus = calcMatchStatus(
          matchData,
          holes,
          teams,
          holeNumber,
          true
        );


        if (_matchStatus.finished) {
          console.log('finished', _matchStatus)
        }

        sendMatchMessage(
          _matchStatus,
          _holeResult
        );

      } catch (error) {

        // Keep existing behavior — messaging failure
        // should not prevent the score update.

      }

      if (autoScoringOn) {
        const _matches_state = _.cloneDeep(matches_state);
        if (_matches_state?.[matchData?.round]?.[matchData?.id]) {
          console.log('matchData', matchData)
          _matches_state[matchData.round][matchData.id] = matchData;
          if (callback) { callback(); }
          return { matches: _matches_state };
        }
      }

      return await golfTournamentHelpers.updateMatchScore(
        database_fns,
        pathViews.golfTournaments,
        pathViews,
        matchData,
        callback
      );

    } catch (error) {
      console.error(error);
      setUpdating(false);
    } finally {
      setUpdating(false);
    }

  }, [
    database_fns,
    pathViews,
    teams,
    holes,
    matches_state
  ]);

  return {
    handleUpdate_golfMatchHoleWinners,
    handleUpdate_golfMatchScore,
    updating
  }
}

